import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowRoundAntiClockwise24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconArrowRoundAntiClockwise24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M6.424 10.464c.882-3.291 3.873-5.112 7.117-4.243 3.267.876 5.118 4.082 4.242 7.349-.875 3.267-4.081 5.118-7.348 4.243a6.2 6.2 0 0 1-2.388-1.22 5 5 0 0 1-.55-.536 3 3 0 0 1-.15-.185l-.002-.004v.001l.001.001-.002-.002a.75.75 0 0 0-1.242.84l.623-.418c-.623.419-.622.419-.622.42l.001.001.002.003.005.008.016.022.051.07q.065.086.186.227c.161.186.4.434.72.702a7.7 7.7 0 0 0 2.963 1.518c4.067 1.09 8.095-1.235 9.185-5.303s-1.236-8.096-5.303-9.185c-3.583-.96-6.926.727-8.429 3.876v-1.9a.75.75 0 0 0-1.5 0V12h5.215a.75.75 0 0 0 0-1.5H6.414z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowRoundAntiClockwise24);
